// extracted by css-extract-rspack-plugin
export default {"popover":"popover-uR6fjV"};